import React from 'react';

import ReactDOM, { render } from 'react-dom';

import { ThemeProvider } from '@material-ui/styles';

import theme from '../../../theme';
import { OnMessageSendInput } from '../../../typescript-types/messages/on-message-send-type';
import { UiDialog } from '../../../ui/ui-dialog';
import {
  LegacyMultiLanguageMessageComposer,
  MLMCProps,
} from '../legacy-multiple-language-message-composer';

import { LanguageCode } from '../../../util/languages';

type InputProps = {
  title: string;
  description: React.ReactNode;
  messageProps: PartialBy<MLMCProps, 'onSendMessage'>;
  onClose: () => void;
};

let resolve: Function;

const MultipleMessageComposerDialog = ({
  title,
  description,
  messageProps,
  onClose,
}: InputProps) => {
  const onSendMessage = async (onMessageSendInput: OnMessageSendInput) => {
    const { languageToMessage, messageType, languageToSubject } = onMessageSendInput;
    resolve({
      languageToMessage,
      messageType,
      languageToSubject,
    });
    onClose();

    // This is a little weird because the multi-language composer expects us to make an async request here, but we just want to resolve the
    // promise with the result
    return {};
  };

  const handleCancel = () => {
    resolve(null);
    onClose();
  };

  return (
    <ThemeProvider theme={theme}>
      <UiDialog onClose={handleCancel} size="xs" title={title}>
        <UiDialog.Content>
          <div className="typo-title">{description}</div>
          {/* PROD-4039 can use the non-legacy MLMC */}
          <LegacyMultiLanguageMessageComposer
            {...messageProps}
            onSendMessage={onSendMessage}
            onError={handleCancel}
          />
        </UiDialog.Content>
      </UiDialog>
    </ThemeProvider>
  );
};

export const collectMessageToLanguage = (
  title: string,
  description: React.ReactNode,
  messageProps: PartialBy<MLMCProps, 'onSendMessage'>,
) => {
  const containerElement = document.createElement('div');
  document.body.appendChild(containerElement);

  const onClose = () => {
    ReactDOM.unmountComponentAtNode(containerElement);
    containerElement.remove();
  };

  render(
    <MultipleMessageComposerDialog
      title={title}
      description={description}
      messageProps={messageProps}
      onClose={onClose}
    />,
    containerElement,
  );
  return new Promise<{
    languageToMessage: Record<LanguageCode, string>;
    messageType: string;
    languageToSubject: Record<LanguageCode, string>;
  } | null>((res) => {
    resolve = res;
  });
};
